import { ROTA_APIS } from "@/api_framework/api_config";
import {
  IRotaManagementRotaUpdatePropsData,
  IRotaManagementShiftUpdateResponse,
} from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setRotaerrorIds } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export type RotaCreationReturnType = {
  status: boolean;
  message: string;
};

export const useRotaUpdateAPI = () => {
  const configuration = useConfiguration();

  const [AppError, setAppError] = useState<string | null>(null);
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (filterParams: IRotaManagementRotaUpdatePropsData, shiftId: string) => {
      dispatch(
        setLoading({
          key: "isPWLInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: RotaCreationReturnType = await axios
          .put(ROTA_APIS?.ROTA_UPDATE_API?.baseURL ?? "", filterParams, {
            params: { id: shiftId },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IRotaManagementShiftUpdateResponse>) => {
            if (res.data.status === true) {
              toast.success("Rota has been updated ");
              //IF COND
              return { status: true, message: "Rota has been updated." };
            } else {
              //ELSE COND
              return { status: false, message: "Could not update Rota." };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            const vv = e.response.data as any;
            captureError(e);
            dispatch(setRotaerrorIds({ data: vv }));

            return { status: false, message: vv.message };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { AppError, setAppError, execute };
};
